import { setSpecificMessage, mac64 } from "valibot";
setSpecificMessage(
  mac64,
  (issue) => `MAC 64-bit invalide: reçu ${issue.received}`,
  "fr"
);